export const JOB_EDUCATION_OPTIONS: string[] = [
    'B.Tech',
    'BCA',
    'B.Com',
    'MBA',
    'B.Sc',
    'MCA',
    'BBA',
    'BA / BA LLB',
    'Any PG',
    'M.Tech',
    'M.Sc',
    'MA',
    'B.Pharma',
    'MBBS',
    'LLB',
    'BDS',
    'B.Arch',
    'Diploma'
];